import { Box, Image, Flex, Heading, Text } from "@chakra-ui/react";
import type { ImageProps } from "@chakra-ui/react";
import type { SbEditableComponentProps } from "types/storyblok";
import type { HeroImageProps } from "./HeroImage.d";

const MAX_CONTAINER_WIDTH = "1440px";

const MIN_HEIGHT = {
  base: "533px",
  md: "600px",
  lg: "731px",
};

export const HeroImage = ({
  srcDesktop,
  srcMobile,
  alt,
  heading,
  subHeading,
  sbEditable,
}: SbEditableComponentProps<HeroImageProps>) => {
  const imageProps: ImageProps = {
    position: "absolute",
    inset: 0,
    right: 4,
    zIndex: -1,
    alt,
    fit: "cover",
    height: "100%",
    minWidth: "100%",
    rounded: { base: "none", md: "xl" },
  };

  return (
    <Box maxW={MAX_CONTAINER_WIDTH} mx="auto" mt={{ base: -4, md: 5 }} {...sbEditable}>
      <Flex position="relative" alignItems="flex-end" minH={MIN_HEIGHT} mx={{ base: 0, md: 4, lg: 8 }} mb={6}>
        <Flex
          direction="column"
          height="100%"
          ml={{ base: 4, md: 10, lg: 20 }}
          my={20}
          mb={{ base: 24, md: 20 }}
          maxW={{ base: "65%", md: "60%", lg: "51%" }}
        >
          {subHeading && (
            <Text
              fontSize="xs"
              color="primary.500"
              textTransform="uppercase"
              fontWeight="bold"
              letterSpacing="1.5px"
              mb={6}
            >
              {subHeading}
            </Text>
          )}
          {heading && (
            <Heading as="h1" variant={{ base: "h2", lg: "h1" }}>
              {heading}
            </Heading>
          )}
        </Flex>
        <Image display={{ base: "block", md: "none" }} src={srcMobile} {...imageProps} />
        <Image display={{ base: "none", md: "block" }} src={srcDesktop} loading="lazy" {...imageProps} />
      </Flex>
    </Box>
  );
};
